let navigateFunction: ((path: string, state?: any) => void) | null = null;

export const setNavigate = (navigate: (path: string, state?: any) => void) => {
    navigateFunction = navigate;
};

export const navigateTo = (path: string, state?: any) => {
    if (navigateFunction) {
        navigateFunction(path, state);
    }
};
